/* Volume discount — "Buy more, save more"
 *
 * Chọn một bậc => đặt ô số lượng của form add-to-cart về đúng số đó.
 * Giá hiển thị chỉ là phần nhìn; tiền thật do Automatic discount của Shopify tính ở giỏ hàng.
 */
if (!customElements.get('volume-discount')) {
  class VolumeDiscount extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.volume-discount__card'));
      if (!this.cards.length) return;

      this.config = this.readConfig();
      this.basePrice = this.config.basePrice || 0;
      this.priceMode = this.dataset.priceMode || this.config.priceMode || 'unit';
      this.moneyFormat = this.config.moneyFormat || '${{amount}}';
      this.sectionId = this.dataset.section;

      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.select(card));
      });

      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('product:variant-change', this.onVariantChange);

      // Khách tự sửa ô số lượng thì bỏ chọn bậc nếu không còn khớp
      const input = this.quantityInput();
      if (input) {
        this.onQuantityInput = this.onQuantityInput.bind(this);
        input.addEventListener('change', this.onQuantityInput);
        this._input = input;
      }

      const selected = this.cards.find((c) => c.classList.contains('is-selected'));
      if (selected) this.applyQuantity(selected, false);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
      if (this._input) this._input.removeEventListener('change', this.onQuantityInput);
    }

    readConfig() {
      const el = this.querySelector('[data-vd-config]');
      if (!el) return {};
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return {};
      }
    }

    quantityInput() {
      const sel = this.dataset.quantityTarget;
      let input = sel ? document.querySelector(sel) : null;
      if (input) return input;
      // dự phòng: ô số lượng trong form add-to-cart gần nhất
      const form =
        document.querySelector('form[data-type="add-to-cart-form"]') ||
        document.querySelector('product-form form');
      return form ? form.querySelector('input[name="quantity"]') : null;
    }

    select(card) {
      this.cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.applyQuantity(card, true);
    }

    applyQuantity(card, notify) {
      const input = this.quantityInput();
      if (!input) return;
      const qty = parseInt(card.dataset.qty, 10);
      if (!qty || qty < 1) return;

      // Tôn trọng giới hạn số lượng của variant nếu theme có đặt
      const max = parseInt(input.getAttribute('max'), 10);
      const value = max && qty > max ? max : qty;

      if (String(input.value) === String(value)) return;
      input.value = value;
      if (notify) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    onQuantityInput() {
      const input = this._input;
      if (!input) return;
      const qty = parseInt(input.value, 10);
      this.cards.forEach((c) => {
        const on = parseInt(c.dataset.qty, 10) === qty;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    onVariantChange(event) {
      const detail = event.detail || {};
      if (this.sectionId && detail.sectionId && String(detail.sectionId) !== String(this.sectionId)) return;

      const variant = detail.variant;
      if (!variant) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      if (typeof variant.price !== 'number') return;

      this.basePrice = variant.price;
      this.repriceCards();
    }

    repriceCards() {
      this.cards.forEach((card) => {
        const qty = parseInt(card.dataset.qty, 10) || 1;
        const pct = parseFloat(card.dataset.percent) || 0;
        const unit = Math.round((this.basePrice * (100 - pct)) / 100);

        const price = this.priceMode === 'total' ? unit * qty : unit;
        const compare = this.priceMode === 'total' ? this.basePrice * qty : this.basePrice;

        const priceEl = card.querySelector('[data-vd-price]');
        const compareEl = card.querySelector('[data-vd-compare]');
        if (priceEl) priceEl.textContent = this.formatMoney(price);
        if (compareEl) compareEl.textContent = this.formatMoney(compare);
      });
    }

    /* Định dạng tiền theo money_format của shop. Hỗ trợ {{amount}},
       {{amount_no_decimals}}, {{amount_with_comma_separator}},
       {{amount_no_decimals_with_comma_separator}}. */
    formatMoney(cents) {
      const format = this.moneyFormat;
      const value = cents / 100;

      const withCommas = (n, decimals) => {
        const fixed = n.toFixed(decimals);
        const parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      };
      const withDots = (n, decimals) => {
        const fixed = n.toFixed(decimals);
        const parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return parts.join(',');
      };

      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => {
        switch (token) {
          case 'amount_no_decimals':
            return withCommas(value, 0);
          case 'amount_with_comma_separator':
            return withDots(value, 2);
          case 'amount_no_decimals_with_comma_separator':
            return withDots(value, 0);
          default:
            return withCommas(value, 2);
        }
      });
    }
  }

  customElements.define('volume-discount', VolumeDiscount);
}
